









import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    props: {
      avatarPosition: String, //  'left' | 'right' | 'top' | 'bottom',
      focused: Boolean // = false;
      // status?: string | null;
    }
});
/*
@Component
export default class ChatBalloon extends Vue {
  @Prop() public avatarPosition?: 'left' | 'right' | 'top' | 'bottom';
  @Prop() public focused: boolean; // = false;
  // status?: string | null;
}*/
